module.exports = __webpack_public_path__ + "static/media/strefa-szybkich-rekrutacji.ede06c34.svg";